import React from 'react'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import "./sliderLoader.css"
const SliderLoader = () => {
    return (
        <div className="slider-loader">
            <LoadingSpinner/>
        </div>
    )
}

export default SliderLoader
